<template>
  <div>
    <!-- 配送单废弃申请 -->
    <baseBreadcrumb :page="$t('message.requestForCancellationOfDeliveryOrder')" :menu="$t('message.warehouse')" />
    <div class="body">
      <!-- 筛选 -->
      <div class="search">
        <div class="tabs">
          <el-tabs v-model="datas.status" type="card" @tab-click="search">
            <!-- 全部 -->
            <!-- <el-tab-pane :label="$t('message.all')" name="''"></el-tab-pane> -->
            <!-- 待确认 -->
            <el-tab-pane :label="$t('message.toBeConfirmed')" name="0"></el-tab-pane>
            <!-- 已确认 -->
            <el-tab-pane :label="$t('message.confirmed')" name="1"></el-tab-pane>
            <!-- 删除 -->
            <!-- <el-tab-pane :label="$t('message.delete')" name="-1"></el-tab-pane> -->
          </el-tabs>
        </div>
        <div class="operationContainer">
          <div class="leftContainer">
            <!-- 开始日期-->
            <div class="item">
              <el-date-picker v-model="datas.datetimeStart" :placeholder="$t('message.startDate')" class="Container"
                type="datetime" default-time="['00:00:00']" value-format="yyyy-MM-dd HH:mm:ss" style="width: 180px">
              </el-date-picker>
            </div>
            <!--  结束日期-->
            <div class="item">
              <el-date-picker v-model="datas.datetimeEnd" :placeholder="$t('message.dateClosed')" class="Container"
                default-time="['23:59:59']" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 180px">
              </el-date-picker>
            </div>
            <!-- 请输入ID-->
            <div class="item">
              <el-input v-model="datas.user_id" :placeholder="$t('message.pleaseEnterID')" class="Container"
                onfocus="this.select()" />
            </div>
            <!--   请输入配送单号-->
            <div class="item">
              <el-input v-model="datas.porder_sn" :placeholder="$t('message.pleaseEnterTheShippingNumber')"
                class="Container" onfocus="this.select()" />
            </div>
            <!--   请输入订单号-->
            <div class="item">
              <el-input v-model="datas.order_sn" :placeholder="$t('message.pleaseEnterTheOrderNumber')"
                class="Container" onfocus="this.select()" />
            </div>
            <!--人员范围-->
            <div class="item">
              <!--  人员范围-->
              <cascader @setUserList="setUserList" :org_id="datas.org_id" ref="cascader" />
            </div>
            <!--  全部人员-->
            <div class="item">
              <el-select v-model="datas.admin_id" :placeholder="$t('message.allPersonnel')" filterable clearable>
                <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="operationContainer">
          <div class="leftContainer">
            <div class="item">
              <!--  搜索 -->
              <el-button type="primary" @click="search">{{
                $t("message.ok")
              }}</el-button>
              <!--  重置 -->
              <!-- <el-button @click="reset">{{ $t("message.reset") }}</el-button> -->
            </div>
          </div>
          <div class="rightContainer">
            <el-button type="primary" class="primary" @click="abandonedList"> {{ $t("message.abandonedList") }}
            </el-button>
          </div>
        </div>
      </div>
      <!-- 列表 -->
      <div class="tableList">
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" @selection-change="handleSelectionChange"
          ref="multipleTable" @cell-click="labelSelection">
          <!-- 序号 -->
          <el-table-column align="center" :label="$t('message.serialNumber')" prop="rowNumber" width="60">
          </el-table-column>
          <el-table-column type="selection" width="45" align="center">
          </el-table-column>
          <!--  申请人-->
          <el-table-column align="center" :label="$t('message.theApplicant')" prop="created_admin.realname">
          </el-table-column>
          <!--    提出废弃时间 -->
          <el-table-column align="center" :label="$t('message.proposedObsolescenceTime')" prop="created_at">
          </el-table-column>
          <!--  配送单号-->
          <el-table-column align="center" :label="$t('message.deliveryNoteNumber')" width="200px">
            <template slot-scope="scope">
              <div class="template">
                <p>{{ scope.row.porder.user.realname }}</p>
                <p>
                  <router-link :to="'/porderDetail?porder_sn=' + scope.row.porder_sn" target="_blank"
                    :style="{ color: scope.row.p_porder ? '#606266' : '' }">
                    {{ scope.row.porder_sn }}</router-link>
                </p>
              </div>
            </template>
          </el-table-column>
          <!--    客户联系截图 -->
          <el-table-column align="center" :label="$t('message.customerScreenshots')" width="220px">
            <template slot-scope="scope">
              <div class="images">
                <span v-for="(item, index) in scope.row.images" :key="index">
                  <el-image style="width: 90px; " :src="item" :preview-src-list="[item]">
                  </el-image>
                </span>
              </div>
            </template>
          </el-table-column>
          <!--    废弃原因 -->
          <el-table-column align="center" :label="$t('message.reasonForAbandonment')" prop="reason">
          </el-table-column>
          <!--    确认人员备注 -->
          <el-table-column align="center" :label="$t('message.confirmationPersonnelRemark')">
            <template slot-scope="scope">
              <el-input type="textarea" v-model="scope.row.confirm_remark" @blur="updateConfirmRemark(scope.row)"
                :disabled="!isAuth(513)">
              </el-input>
            </template>
          </el-table-column>
          <!--    确认人 -->
          <el-table-column align="center" :label="$t('message.affirmName')" prop="confirm_admin.realname">
          </el-table-column>
          <!--    状态 -->
          <el-table-column align="center" :label="$t('message.status')" prop="status_name">
          </el-table-column>
          <!--    操作 -->
          <el-table-column align="center" :label="$t('message.operation')">
            <template slot-scope="scope">
              <p style="margin-bottom: 15px;" v-if="scope.row.status == 0 && isAuth(512)">
                <!-- 确认 -->
                <el-button type="primary" size="small" @click="discardConfirm(scope.row.id)">{{
                  $t("message.confirm")
                }}</el-button>
              </p>
              <!-- 删除 -->
              <p v-if="scope.row.status == 0 && isAuth(514)"> <el-button type="primary" class="dark" size="small"
                  @click="discardDelete(scope.row.id)">{{
                    $t("message.delete")
                  }}</el-button></p>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[50, 80, 100, 200]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
      <!-- 废品打印 -->
      <div v-show="false">
        <div ref="abandoned">
          <abandoned />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import abandoned from "@/components/Printedsheet/abandoned.vue";
export default {
  components: {
    abandoned
  },
  data() {
    return {
      datas: {
        order_sn: "",
        datetimeStart: "",
        datetimeEnd: "",
        user_id: "",
        status: "0",
        org_id: "",
        work_group: "",
        admin_id: "",
        page: 1,
        pageSize: 50,
      },
      total: 0,
      tableData: [],
      userList: [],
      porder_sn: [],//选中的配送单
    };
  },
  computed: {
    y() {
      return this.$store.state.authWorkGroupAdmin.y;
    },
    g() {
      return this.$store.state.authWorkGroupAdmin.g;
    },
    p() {
      return this.$store.state.authWorkGroupAdmin.p;
    },
  },
  created() {
    this.discardList()
  },
  methods: {
    // 列表
    discardList() {
      this.$api.porderApi.discardList(this.datas).then(res => {
        this.tableData = res.data.data
        this.total = res.data.total
        this.selectList = []
      })
    },
    // 搜索
    search() {
      this.datas.page = 1;
      this.discardList();
    },
    // 重置
    reset() {
      this.datas = {
        order_sn: "",
        datetimeStart: "",
        datetimeEnd: "",
        user_id: "",
        status: "",
        org_id: "",
        work_group: "",
        admin_id: "",
        page: 1,
        pageSize: 50,
        y_id: '',
        g_id: '',
        p_id: '',
      };
      this.$refs.cascader.orgId = [];
      this.discardList();
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.discardList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.discardList();
    },
    // 整个框选择
    labelSelection(row, column) {
      if (column.className == "el-table-column--selection") {
        this.$refs.multipleTable.toggleRowSelection(row);
      }
    },
    handleSelectionChange(val) {
      this.selectList = val;
    },
    // 人员范围
    setUserList(data) {
      this.userList = data.userList;
      this.datas.org_id = data.id;
      this.datas.admin_id = "";
    },
    // 修改审核备注
    updateConfirmRemark(item) {
      let datas = {
        id: item.id,
        confirm_remark: item.confirm_remark
      }
      this.$api.porderApi.discardUpdateConfirmRemark(datas).then(res => {
        this.$message.success(res.msg)
      })
    },
    //审核确认
    discardConfirm(id) {
      this.$confirm('确认后该配送单将进行废弃操作，单子状态完结，系统自动发放废弃成功邮件通知客户，请注意，废弃后无法回退，请再次确认?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.$api.porderApi.discardConfirm({ id }).then(res => {
          this.$message.success(res.msg)
          this.discardList();
        })
      }).catch(() => {

      });
    },
    //删除
    discardDelete(id) {
      this.$confirm('删除后配送单将取消废弃标识，是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.$api.porderApi.discardDelete({ id }).then(res => {
          this.$message.success(res.msg)
          this.discardList();
        })
      }).catch(() => {

      });
    },
    // 打印废弃单
    abandonedList() {
      if (this.selectList == false) return this.$message.error('未选择列表')
      let boxIds = []
      this.selectList.forEach(item => {
        item.porder.porder_freight.forEach(box => {
          boxIds.push(box.id)
        })
      })
      this.$api.getMaitouData({ freightIds: boxIds }).then((res) => {
        res.data.forEach((item) => {
          let itemData = {}
          this.selectList.forEach(porder => {
            porder.porder.porder_freight.forEach(box => {
              if (box.id == item.id) {
                itemData = porder
                itemData.boxTotal = porder.porder.porder_freight.length
              }
            })
          })
          item.boxTotal = itemData.boxTotal;
          item.reason = itemData.reason
          item.created_at = itemData.created_at
          item.abandon = itemData.abandon_type == 1 ? '客户要求废弃' : '联系不上超时废弃'
          // 二维码
          this.$QRCode.toDataURL(
            item.encrypt_freight_id,
            { errorCorrectionLevel: "L", margin: 2, width: 128 },
            (err, url) => {
              if (err) throw err;
              item.QRImgUrl = url;
            }
          );
        });
        let datas = {
          logistics: '废弃',
          printData: res.data,
        }
        // console.log(datas);
        this.$store.commit('setPrintData', datas)
        this.$nextTick(() => {
          this.$print(this.$refs.abandoned);
          this.$store.commit('setPrintData', {})
        });
      });
    }
  }
}
</script>
<style lang='scss' scoped>
.search {
  /deep/.el-input__inner {
    width: 217px;
  }
}

.tableList {
  margin: 20px 0;

  /deep/.el-button {
    width: 92px;
  }
}

.table {
  ul {
    border: 1px solid #edeff4;
    border-top: 0;
    padding: 0;

    &:nth-child(1) {
      border-top: 1px solid #edeff4;
    }

    li {
      border-right: 1px solid #edeff4;
      padding: 10px 0;

      &:nth-last-child(1) {
        border: 0;
      }
    }

    .flex2 {
      flex: 2;
    }
  }
}

.item {
  margin-right: 20px;
}

.operationContainer {
  display: flex;
  margin-bottom: 20px;

  /deep/.el-input__inner {
    width: 200px;
  }

  .el-date-editor {
    width: 200px;
    margin-right: 20px;
  }

  .leftContainer {
    flex: 7;
  }

  .rightContainer {
    flex: 1;
  }
}

/deep/.cell {
  padding: 0 3px !important;
}

.content {
  padding: 0 20px;


  /deep/.el-radio {
    margin-bottom: 20px;
  }
}

.template {
  text-align: left;
}

/deep/.el-textarea__inner {
  height: 100px;
  padding: 3px !important;

}

a {
  color: #b4272d;

  &:hover {
    text-decoration: underline;
  }
}

/deep/ .el-table .el-table__cell {
  padding: 5px 0;
}

.images {
  .el-image:nth-child(odd) {
    margin-right: 10px;
  }
}
</style>